import React from 'react'
import {connect} from 'react-redux'
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import AddBtn from './addBtn'
import ItemList from './itemList'
import PerItem from './perItem'
import * as actions from '../reducers/list'


class Permission extends React.Component {
    componentDidMount() {
        const {dispatch} = this.props
        dispatch(actions.getRoleList())
        dispatch(actions.getPermissionList())
    }
    addRole = (text) => {
        const {dispatch} = this.props
        if (text) {
            const name = {
                name: text
            }
            dispatch(actions.addRole(name))    
        }
        return Promise
    }
    onDeleteRole = (id) => {
        const {dispatch} = this.props
        dispatch({type: actions.SHOW_MODAL,key: 'isDelRole',id})
        // dispatch(deleteRole(id))
    }
    addPermission = (text) => {
        const {dispatch} = this.props
        if (text) {
            const name = {
                name: text
            }
            dispatch(actions.addPermission(name))    
        }
        return Promise
    }
    onDeletePermission = (id) => {
        const {dispatch} = this.props
        dispatch({type: actions.SHOW_MODAL,key: 'isDelPermission',id})
        // dispatch(deletePermission(id))
    }
    onTodoClick = (id) => {
        const {dispatch} = this.props;
        dispatch(actions.getDetailRole(id))
    }
    onChangePermission = (permissionId) => {
        const { dispatch,currRole } = this.props
        dispatch(actions.changeRolePermission(currRole.id,permissionId))
    }
    handleShowIcon = (name) => {
        const {dispatch} = this.props
        dispatch({type: actions.CHANGE_CURRENT_NAME,value: name})
    }
    handleHideIcon = () => {
        const {dispatch} = this.props
        dispatch({ type: actions.CHANGE_CURRENT_NAME,value: ''})
    }
    render() {
        const {dispatch,roles,permissions,showModal,currentName, currRole, permissionMap,isDelete} = this.props
        return(
            <div style={{display: 'flex',justifyContent: 'flex-start'}}>
                <Paper style={{width:350,display:'flex',flexDirection: 'column',alignItems: 'center',marginRight: 24}}>
                    <h3>角色：</h3>
                    <ItemList 
                        items={roles} 
                        onDelete={this.onDeleteRole} 
                        onTodoClick={this.onTodoClick} 
                        isShowCheckbox={false}
                        checkIds={[]}
                        onChangePermission={()=>{}}
                        currActive={currRole.id}
                        isHasPermission={permissionMap['权限设置_删除']}
                    />
                    {permissionMap['权限设置_新增'] && <AddBtn onAddClick={(text) => this.addRole(text)} isShowCheckbox={false} />}
                </Paper> 
                <Paper style={{height: 'calc(100vh - 112px)',flex: 4,display:'flex',flexDirection: 'column',justifyContent: 'space-between',alignItems: 'center'}}>
                    <h3>权限设置：</h3>
                    {/* <ItemList 
                        items={permissions} 
                        onDelete={this.onDeletePermission} 
                        onTodoClick={()=>{}} 
                        isShowCheckbox={true}
                        checkIds={currRole.rolePermissions.map(item=>item.permissionId)}
                        onChangePermission={this.onChangePermission}
                        isHasPermission={permissionMap['权限设置_删除']}
                    /> */}
                    <PerItem 
                        items={permissions} 
                        onDelete={this.onDeletePermission} 
                        onTodoClick={()=>{}} 
                        isShowCheckbox={true}
                        checkIds={currRole.rolePermissions.map(item=>item.permissionId)}
                        onChangePermission={this.onChangePermission}
                        isHasPermission={permissionMap['权限设置_删除']}
                        isDelete={isDelete}
                        handleShowIcon={this.handleShowIcon}
                        handleHideIcon={this.handleHideIcon}
                        currentName={currentName}
                    />
                    {permissionMap['权限设置_新增'] && <AddBtn onAddClick={(text) => this.addPermission(text)} isShowCheckbox={true} />}
                </Paper> 
                <Dialog
                    open={showModal.isDelPermission}
                    onClose={() => dispatch({type: actions.HIDE_MODAL})}
                >
                    <DialogContent>
                        <DialogContentText>确定删除此权限吗？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={() => dispatch({type: actions.HIDE_MODAL})} >取消</Button>
                        <Button color="primary" onClick={() => dispatch(actions.deletePermission())}>确定</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={showModal.isDelRole}
                    onClose={() => dispatch({type: actions.HIDE_MODAL})}
                >
                    <DialogContent>
                        <DialogContentText>确定删除此角色吗？</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={() => dispatch({type: actions.HIDE_MODAL})} >取消</Button>
                        <Button color="primary" onClick={() => dispatch(actions.deleteRole())}>确定</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.permission,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(Permission)


// WEBPACK FOOTER //
// ./src/pages/home/routes/permission/components/list.js